










import { Component, Vue, Prop } from 'vue-property-decorator';
import { Auth } from 'aws-amplify';

@Component({
  components: {},
})
export default class UserInfo extends Vue {

  @Prop() public readonly username: string;
  @Prop() public readonly signedIn: boolean;

  public signOut() {
    Auth.signOut();
  }
}

